<script lang="ts">
	import { TextRowSelector } from "misc-ui"
	import GroupSettings from "../../GroupSettings.svelte"
	import { GroupEditorController } from "../../../GroupEditorController"
	import type { DeviceGroupSlot } from "luxedo-data"
	import InputsOverlapProperties from "./Inputs_OverlapProperties.svelte"
	import InputsSlotOverlaps from "./Inputs_SlotOverlaps.svelte"
	import { GroupOverlapController } from "../GroupOverlapController"

	const MENUS = {
		Overlaps: InputsSlotOverlaps,
		Properties: InputsOverlapProperties,
		Group: GroupSettings,
	}

	type MenuName = keyof typeof MENUS

	let selectedOverlap: GroupOverlapController.OverlapInstance = $state()
	let availableMenus = $derived(
		selectedOverlap ? ["Overlaps", "Properties", "Group"] : ["Overlaps", "Group"]
	)

	let selectedMenu: MenuName = $state("Overlaps")
	let Menu = $derived(MENUS[selectedMenu])

	GroupOverlapController.subscribe((ctx) => {
		selectedOverlap =
			ctx.overlapInstances.find((instance) => instance.id === ctx.selectedOverlapInstance) ??
			undefined
	})

	function onSelect(menu: MenuName) {
		selectedMenu = menu
	}
</script>

<div id="group-align-inputs">
	<TextRowSelector options={availableMenus} onChange={onSelect} selectedOption={selectedMenu} />
	<Menu />
</div>

<style>
	#group-align-inputs {
		padding: 1rem;
		display: flex;
		flex-direction: column;
	}

	#group-align-inputs :global(.slot-properties-container) {
		margin: 0;
	}
	#group-align-inputs :global(.text-row-selector) {
		margin-bottom: 0.5rem;
	}

	#group-align-inputs :global(.overlap-instances-container) {
		padding-left: 0;
		margin: 0;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	#group-align-inputs :global(.overlap-slots) {
		overflow-y: auto;
		flex-wrap: wrap;
		gap: 1rem;
	}

	#group-align-inputs :global(#blend-zone-button) {
		display: none;
	}

	#group-align-inputs :global(.overlap-slot-instance h3) {
		margin-bottom: 0.25rem;
	}

	#group-align-inputs :global(.group-align-heading) {
		justify-content: space-between;
	}

	:global(.isMobile #group-editor) #group-align-inputs :global(.instance-selector) {
		margin-bottom: 0;
		height: 100%;
	}
</style>
